import api from '../api/axiosInstance';

export interface EppEnm {
  id: string;
  name: string;
  description: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface CreateEppEnmPayload {
  name: string;
  description?: string;
}

/**
 * CRUD for EPP-sourced ENM endpoints (RLCS-2409). Backed by the BFF /api/epp-enm.
 * Only used when EPP is enabled (see eppConfig).
 */
export const eppEnmService = {
  getAll: () => api.get<EppEnm[]>('/api/epp-enm'),
  getOne: (id: string) => api.get<EppEnm>(`/api/epp-enm/${id}`),
  create: (payload: CreateEppEnmPayload) => api.post<EppEnm>('/api/epp-enm', payload),
  update: (id: string, payload: Partial<CreateEppEnmPayload>) =>
    api.put<EppEnm>(`/api/epp-enm/${id}`, payload),
  remove: (id: string) => api.delete(`/api/epp-enm/${id}`)
};
